
      var $parcel$global = globalThis;
    let $5bf249769eb894d1$var$wasm;
let $5bf249769eb894d1$var$WASM_VECTOR_LEN = 0;
let $5bf249769eb894d1$var$cachedUint8ArrayMemory0 = null;
function $5bf249769eb894d1$var$getUint8ArrayMemory0() {
    if ($5bf249769eb894d1$var$cachedUint8ArrayMemory0 === null || $5bf249769eb894d1$var$cachedUint8ArrayMemory0.byteLength === 0) $5bf249769eb894d1$var$cachedUint8ArrayMemory0 = new Uint8Array($5bf249769eb894d1$var$wasm.memory.buffer);
    return $5bf249769eb894d1$var$cachedUint8ArrayMemory0;
}
const $5bf249769eb894d1$var$cachedTextEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : {
    encode: ()=>{
        throw Error('TextEncoder not available');
    }
};
const $5bf249769eb894d1$var$encodeString = typeof $5bf249769eb894d1$var$cachedTextEncoder.encodeInto === 'function' ? function(arg, view) {
    return $5bf249769eb894d1$var$cachedTextEncoder.encodeInto(arg, view);
} : function(arg, view) {
    const buf = $5bf249769eb894d1$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
function $5bf249769eb894d1$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $5bf249769eb894d1$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $5bf249769eb894d1$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $5bf249769eb894d1$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $5bf249769eb894d1$var$getUint8ArrayMemory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $5bf249769eb894d1$var$getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = $5bf249769eb894d1$var$encodeString(arg, view);
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }
    $5bf249769eb894d1$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
let $5bf249769eb894d1$var$cachedDataViewMemory0 = null;
function $5bf249769eb894d1$var$getDataViewMemory0() {
    if ($5bf249769eb894d1$var$cachedDataViewMemory0 === null || $5bf249769eb894d1$var$cachedDataViewMemory0.buffer.detached === true || $5bf249769eb894d1$var$cachedDataViewMemory0.buffer.detached === undefined && $5bf249769eb894d1$var$cachedDataViewMemory0.buffer !== $5bf249769eb894d1$var$wasm.memory.buffer) $5bf249769eb894d1$var$cachedDataViewMemory0 = new DataView($5bf249769eb894d1$var$wasm.memory.buffer);
    return $5bf249769eb894d1$var$cachedDataViewMemory0;
}
const $5bf249769eb894d1$var$cachedTextDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
}) : {
    decode: ()=>{
        throw Error('TextDecoder not available');
    }
};
if (typeof TextDecoder !== 'undefined') $5bf249769eb894d1$var$cachedTextDecoder.decode();
function $5bf249769eb894d1$var$getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $5bf249769eb894d1$var$cachedTextDecoder.decode($5bf249769eb894d1$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
function $5bf249769eb894d1$var$addToExternrefTable0(obj) {
    const idx = $5bf249769eb894d1$var$wasm.__externref_table_alloc();
    $5bf249769eb894d1$var$wasm.__wbindgen_export_4.set(idx, obj);
    return idx;
}
function $5bf249769eb894d1$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = $5bf249769eb894d1$var$addToExternrefTable0(e);
        $5bf249769eb894d1$var$wasm.__wbindgen_exn_store(idx);
    }
}
function $5bf249769eb894d1$var$isLikeNone(x) {
    return x === undefined || x === null;
}
function $5bf249769eb894d1$export$b3571188c770cc5a() {
    $5bf249769eb894d1$var$wasm.start();
}
function $5bf249769eb894d1$export$aaea0094c1c69714() {
    $5bf249769eb894d1$var$wasm.greet();
}
function $5bf249769eb894d1$export$e16d8520af44a096(a, b) {
    const ret = $5bf249769eb894d1$var$wasm.add(a, b);
    return ret;
}
function $5bf249769eb894d1$var$takeFromExternrefTable0(idx) {
    const value = $5bf249769eb894d1$var$wasm.__wbindgen_export_4.get(idx);
    $5bf249769eb894d1$var$wasm.__externref_table_dealloc(idx);
    return value;
}
function $5bf249769eb894d1$var$getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = $5bf249769eb894d1$var$getDataViewMemory0();
    const result = [];
    for(let i = ptr; i < ptr + 4 * len; i += 4)result.push($5bf249769eb894d1$var$wasm.__wbindgen_export_4.get(mem.getUint32(i, true)));
    $5bf249769eb894d1$var$wasm.__externref_drop_slice(ptr, len);
    return result;
}
function $5bf249769eb894d1$export$fa4096e7876d3a7(raw_content) {
    const ptr0 = $5bf249769eb894d1$var$passStringToWasm0(raw_content, $5bf249769eb894d1$var$wasm.__wbindgen_malloc, $5bf249769eb894d1$var$wasm.__wbindgen_realloc);
    const len0 = $5bf249769eb894d1$var$WASM_VECTOR_LEN;
    const ret = $5bf249769eb894d1$var$wasm.load_graph(ptr0, len0);
    if (ret[3]) throw $5bf249769eb894d1$var$takeFromExternrefTable0(ret[2]);
    var v2 = $5bf249769eb894d1$var$getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
    $5bf249769eb894d1$var$wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
    return v2;
}
function $5bf249769eb894d1$export$44464632126ab176(raw_content) {
    const ptr0 = $5bf249769eb894d1$var$passStringToWasm0(raw_content, $5bf249769eb894d1$var$wasm.__wbindgen_malloc, $5bf249769eb894d1$var$wasm.__wbindgen_realloc);
    const len0 = $5bf249769eb894d1$var$WASM_VECTOR_LEN;
    const ret = $5bf249769eb894d1$var$wasm.generate_walks(ptr0, len0);
    if (ret[2]) throw $5bf249769eb894d1$var$takeFromExternrefTable0(ret[1]);
    return $5bf249769eb894d1$var$takeFromExternrefTable0(ret[0]);
}
function $5bf249769eb894d1$export$881c7f900a62cb88(raw_content) {
    let deferred3_0;
    let deferred3_1;
    try {
        const ptr0 = $5bf249769eb894d1$var$passStringToWasm0(raw_content, $5bf249769eb894d1$var$wasm.__wbindgen_malloc, $5bf249769eb894d1$var$wasm.__wbindgen_realloc);
        const len0 = $5bf249769eb894d1$var$WASM_VECTOR_LEN;
        const ret = $5bf249769eb894d1$var$wasm.summary_graph(ptr0, len0);
        var ptr2 = ret[0];
        var len2 = ret[1];
        if (ret[3]) {
            ptr2 = 0;
            len2 = 0;
            throw $5bf249769eb894d1$var$takeFromExternrefTable0(ret[2]);
        }
        deferred3_0 = ptr2;
        deferred3_1 = len2;
        return $5bf249769eb894d1$var$getStringFromWasm0(ptr2, len2);
    } finally{
        $5bf249769eb894d1$var$wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
    }
}
async function $5bf249769eb894d1$var$__wbg_load(module1, imports) {
    if (typeof Response === 'function' && module1 instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') try {
            return await WebAssembly.instantiateStreaming(module1, imports);
        } catch (e) {
            if (module1.headers.get('Content-Type') != 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module1.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module1, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module1
        };
        else return instance;
    }
}
function $5bf249769eb894d1$var$__wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_String_8f0eb39a4a4c2f66 = function(arg0, arg1) {
        const ret = String(arg1);
        const ptr1 = $5bf249769eb894d1$var$passStringToWasm0(ret, $5bf249769eb894d1$var$wasm.__wbindgen_malloc, $5bf249769eb894d1$var$wasm.__wbindgen_realloc);
        const len1 = $5bf249769eb894d1$var$WASM_VECTOR_LEN;
        $5bf249769eb894d1$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $5bf249769eb894d1$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbg_alert_ce1447fd3b348a46 = function(arg0, arg1) {
        alert($5bf249769eb894d1$var$getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbg_buffer_609cc3eee51ed158 = function(arg0) {
        const ret = arg0.buffer;
        return ret;
    };
    imports.wbg.__wbg_call_672a4d21634d4a24 = function() {
        return $5bf249769eb894d1$var$handleError(function(arg0, arg1) {
            const ret = arg0.call(arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_call_7cccdd69e0791ae2 = function() {
        return $5bf249769eb894d1$var$handleError(function(arg0, arg1, arg2) {
            const ret = arg0.call(arg1, arg2);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_crypto_ed58b8e10a292839 = function(arg0) {
        const ret = arg0.crypto;
        return ret;
    };
    imports.wbg.__wbg_error_524f506f44df1645 = function(arg0) {
        console.error(arg0);
    };
    imports.wbg.__wbg_error_7534b8e9a36f1ab4 = function(arg0, arg1) {
        let deferred0_0;
        let deferred0_1;
        try {
            deferred0_0 = arg0;
            deferred0_1 = arg1;
            console.error($5bf249769eb894d1$var$getStringFromWasm0(arg0, arg1));
        } finally{
            $5bf249769eb894d1$var$wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
        }
    };
    imports.wbg.__wbg_getRandomValues_bcb4912f16000dc4 = function() {
        return $5bf249769eb894d1$var$handleError(function(arg0, arg1) {
            arg0.getRandomValues(arg1);
        }, arguments);
    };
    imports.wbg.__wbg_log_c222819a41e063d3 = function(arg0) {
        console.log(arg0);
    };
    imports.wbg.__wbg_msCrypto_0a36e2ec3a343d26 = function(arg0) {
        const ret = arg0.msCrypto;
        return ret;
    };
    imports.wbg.__wbg_new_405e22f390576ce2 = function() {
        const ret = new Object();
        return ret;
    };
    imports.wbg.__wbg_new_5e0be73521bc8c17 = function() {
        const ret = new Map();
        return ret;
    };
    imports.wbg.__wbg_new_78feb108b6472713 = function() {
        const ret = new Array();
        return ret;
    };
    imports.wbg.__wbg_new_8a6f238a6ece86ea = function() {
        const ret = new Error();
        return ret;
    };
    imports.wbg.__wbg_new_a12002a7f91c75be = function(arg0) {
        const ret = new Uint8Array(arg0);
        return ret;
    };
    imports.wbg.__wbg_newnoargs_105ed471475aaf50 = function(arg0, arg1) {
        const ret = new Function($5bf249769eb894d1$var$getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_newwithbyteoffsetandlength_d97e637ebe145a9a = function(arg0, arg1, arg2) {
        const ret = new Uint8Array(arg0, arg1 >>> 0, arg2 >>> 0);
        return ret;
    };
    imports.wbg.__wbg_newwithlength_a381634e90c276d4 = function(arg0) {
        const ret = new Uint8Array(arg0 >>> 0);
        return ret;
    };
    imports.wbg.__wbg_node_02999533c4ea02e3 = function(arg0) {
        const ret = arg0.node;
        return ret;
    };
    imports.wbg.__wbg_process_5c1d670bc53614b8 = function(arg0) {
        const ret = arg0.process;
        return ret;
    };
    imports.wbg.__wbg_randomFillSync_ab2cfe79ebbf2740 = function() {
        return $5bf249769eb894d1$var$handleError(function(arg0, arg1) {
            arg0.randomFillSync(arg1);
        }, arguments);
    };
    imports.wbg.__wbg_require_79b1e9274cde3c87 = function() {
        return $5bf249769eb894d1$var$handleError(function() {
            const ret = module.require;
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_set_37837023f3d740e8 = function(arg0, arg1, arg2) {
        arg0[arg1 >>> 0] = arg2;
    };
    imports.wbg.__wbg_set_3f1d0b984ed272ed = function(arg0, arg1, arg2) {
        arg0[arg1] = arg2;
    };
    imports.wbg.__wbg_set_65595bdd868b3009 = function(arg0, arg1, arg2) {
        arg0.set(arg1, arg2 >>> 0);
    };
    imports.wbg.__wbg_set_8fc6bf8a5b1071d1 = function(arg0, arg1, arg2) {
        const ret = arg0.set(arg1, arg2);
        return ret;
    };
    imports.wbg.__wbg_stack_0ed75d68575b0f3c = function(arg0, arg1) {
        const ret = arg1.stack;
        const ptr1 = $5bf249769eb894d1$var$passStringToWasm0(ret, $5bf249769eb894d1$var$wasm.__wbindgen_malloc, $5bf249769eb894d1$var$wasm.__wbindgen_realloc);
        const len1 = $5bf249769eb894d1$var$WASM_VECTOR_LEN;
        $5bf249769eb894d1$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $5bf249769eb894d1$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_88a902d13a557d07 = function() {
        const ret = typeof $parcel$global === 'undefined' ? null : $parcel$global;
        return $5bf249769eb894d1$var$isLikeNone(ret) ? 0 : $5bf249769eb894d1$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0 = function() {
        const ret = typeof globalThis === 'undefined' ? null : globalThis;
        return $5bf249769eb894d1$var$isLikeNone(ret) ? 0 : $5bf249769eb894d1$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_SELF_37c5d418e4bf5819 = function() {
        const ret = typeof self === 'undefined' ? null : self;
        return $5bf249769eb894d1$var$isLikeNone(ret) ? 0 : $5bf249769eb894d1$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_WINDOW_5de37043a91a9c40 = function() {
        const ret = typeof window === 'undefined' ? null : window;
        return $5bf249769eb894d1$var$isLikeNone(ret) ? 0 : $5bf249769eb894d1$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_subarray_aa9065fa9dc5df96 = function(arg0, arg1, arg2) {
        const ret = arg0.subarray(arg1 >>> 0, arg2 >>> 0);
        return ret;
    };
    imports.wbg.__wbg_versions_c71aa1626a93e0a1 = function(arg0) {
        const ret = arg0.versions;
        return ret;
    };
    imports.wbg.__wbindgen_error_new = function(arg0, arg1) {
        const ret = new Error($5bf249769eb894d1$var$getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = $5bf249769eb894d1$var$wasm.__wbindgen_export_4;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
    };
    imports.wbg.__wbindgen_is_function = function(arg0) {
        const ret = typeof arg0 === 'function';
        return ret;
    };
    imports.wbg.__wbindgen_is_object = function(arg0) {
        const val = arg0;
        const ret = typeof val === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbindgen_is_string = function(arg0) {
        const ret = typeof arg0 === 'string';
        return ret;
    };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        const ret = arg0 === undefined;
        return ret;
    };
    imports.wbg.__wbindgen_memory = function() {
        const ret = $5bf249769eb894d1$var$wasm.memory;
        return ret;
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = $5bf249769eb894d1$var$getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error($5bf249769eb894d1$var$getStringFromWasm0(arg0, arg1));
    };
    return imports;
}
function $5bf249769eb894d1$var$__wbg_init_memory(imports, memory) {}
function $5bf249769eb894d1$var$__wbg_finalize_init(instance, module1) {
    $5bf249769eb894d1$var$wasm = instance.exports;
    $5bf249769eb894d1$var$__wbg_init.__wbindgen_wasm_module = module1;
    $5bf249769eb894d1$var$cachedDataViewMemory0 = null;
    $5bf249769eb894d1$var$cachedUint8ArrayMemory0 = null;
    $5bf249769eb894d1$var$wasm.__wbindgen_start();
    return $5bf249769eb894d1$var$wasm;
}
function $5bf249769eb894d1$export$2ec80ee76a9348bf(module1) {
    if ($5bf249769eb894d1$var$wasm !== undefined) return $5bf249769eb894d1$var$wasm;
    if (typeof module1 !== 'undefined') {
        if (Object.getPrototypeOf(module1) === Object.prototype) ({ module: module1 } = module1);
        else console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
    const imports = $5bf249769eb894d1$var$__wbg_get_imports();
    $5bf249769eb894d1$var$__wbg_init_memory(imports);
    if (!(module1 instanceof WebAssembly.Module)) module1 = new WebAssembly.Module(module1);
    const instance = new WebAssembly.Instance(module1, imports);
    return $5bf249769eb894d1$var$__wbg_finalize_init(instance, module1);
}
var $bbba63b99a122cfd$exports = {};
$bbba63b99a122cfd$exports = import.meta.resolve("lWLpV");


async function $5bf249769eb894d1$var$__wbg_init(module_or_path) {
    if ($5bf249769eb894d1$var$wasm !== undefined) return $5bf249769eb894d1$var$wasm;
    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) ({ module_or_path: module_or_path } = module_or_path);
        else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
    }
    if (typeof module_or_path === 'undefined') module_or_path = new URL($bbba63b99a122cfd$exports);
    const imports = $5bf249769eb894d1$var$__wbg_get_imports();
    if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
    $5bf249769eb894d1$var$__wbg_init_memory(imports);
    const { instance: instance, module: module1 } = await $5bf249769eb894d1$var$__wbg_load(await module_or_path, imports);
    return $5bf249769eb894d1$var$__wbg_finalize_init(instance, module1);
}
var $5bf249769eb894d1$export$2e2bcd8739ae039 = $5bf249769eb894d1$var$__wbg_init;


async function $e240b9693eda3573$var$load_wasm() {
    await $5bf249769eb894d1$export$2e2bcd8739ae039();
}
async function $e240b9693eda3573$var$parse_tsgFile(fileContent) {
    // Parse the TSG file content
    // This is a placeholder function. You need to implement the actual parsing logic.
    await $e240b9693eda3573$var$load_wasm();
    let summary = $5bf249769eb894d1$export$fa4096e7876d3a7(fileContent);
    return summary; // Return parsed data
}
window.parse_tsgFile = $e240b9693eda3573$var$parse_tsgFile;


//# sourceMappingURL=app.97f6e6c1.js.map
